// Global error boundary — prevents a render crash from producing a blank white page.

import { Component } from "react";
import type { ReactNode, ErrorInfo, JSX } from "react";

interface Props  { children: ReactNode; }
interface State  { error: Error | null; }

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(_error: Error, info: ErrorInfo): void {
    console.error("[AdminErrorBoundary]", _error, info.componentStack);
  }

  override render(): JSX.Element | ReactNode {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-slate-100 flex items-center justify-center p-8">
          <div className="bg-white rounded-xl shadow-md max-w-lg w-full p-8 space-y-4">
            <h1 className="text-lg font-semibold text-red-600">Something went wrong</h1>
            <p className="text-sm text-slate-600 font-mono break-all">
              {this.state.error.message}
            </p>
            <button
              onClick={() => this.setState({ error: null })}
              className="px-4 py-2 text-sm rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700"
            >
              Try again
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
